<template>
  <div class="questionnaire-content">
    <Icon
      class="questionnaire__icon-back"
      icon="ui-arrow-left"
      @click="setStep('Register')"
    />
    <div class="questionnaire-content__block -underline-">
      <p class="questionnaire__title -min-margin-">
        Дорогой участник!
      </p>
      <p class="questionnaire__description -xl-">
        Без регистрации в Телеграм-боте ты не сможешь вступить в сборную и факультет, 
        а также не будешь получать уведомления об актуальных событиях курса и ссылки 
        на полезные материалы. Мы просим тебя активировать бота и не терять эту возможность!
      </p>
    </div>
    <div class="questionnaire-content__block">
      <p class="questionnaire-content__title">
        Как зарегистрироваться в Телеграме?
      </p>
    </div>
    <div class="questionnaire-content__block">
      <List :list="stepList" />
    </div>
    <div class="questionnaire-content__block">
      <p class="questionnaire-content-postscript">
        <span class="questionnaire-content-postscript__highlight">P.S.</span>
        <span>Не забудь разрешить Телеграму отправлять тебе уведомления</span>
      </p>
    </div>
  </div>
</template>

<script>
import List from './components/List';
export default {
  components: {
    List
  },
  data: () => ({
    stepList: [
      {
        id: 0,
        name: 'Необходимо скачать и установить Telegram на свой телефон или компьютер.'
      },
      {
        id: 1,
        name: 'После установки программы появится окно «Start messaging», нажими на него.',
        buttonList: [
          {
            id: 0,
            name: 'Скачать для iOS',
            icon: 'apple',
            href: 'https://apps.apple.com/app/telegram-messenger/id686449807'
          },
          {
            id: 1,
            name: 'Скачать для Android',
            icon: 'android',
            href: 'https://play.google.com/store/apps/details?id=org.telegram.messenger'
          },
          {
            id: 2,
            name: 'Скачать для macOS',
            icon: 'apple',
            href: 'https://desktop.telegram.org/'
          },
          {
            id: 3,
            name: 'Скачать для Windows',
            icon: 'windows',
            href: 'https://desktop.telegram.org/'
          }
        ]
      },
      {
        id: 2,
        name: 'Далее введи свой номер мобильного телефона, к которому будет привязан аккаунт Telegram.'
      },
      {
        id: 3,
        name: 'После тебе придет код, с помощью которого произойдет подтверждение твоего номера и привязка к аккаунту'
      },
      {
        id: 4,
        name: 'Далее введи свои имя и фамилию, как будет записано в твоем аккаунте.'
      },
      {
        id: 5,
        name: 'Все готово! Теперь ты зарегистрирован и можешь использовать все возможности курса!'
      }
    ]
  }),
  methods: {
    setStep(step) {
      this.$emit('setStep', step);
    }
  }
};
</script>

<style scoped>
.questionnaire__icon-back {
  display: unset;
}
</style>
